import React from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { Button } from 'components/Button';
import Icon from 'components/Icon/Icon';
import { colors, transition } from 'theme';

const ArrowNavigation = styled(
  ({
    className,
    nextPage,
    prevPage,
    current,
    total,
    outset,
    showDropShadow,
    buttonColor,
    ...props
  }) => {
    const title = {
      prev: getText('Previous page'),
      next: getText('Next page'),
    };
    const prevDisabled = current <= 0;
    const nextDisabled = current >= total - 1;
    return (
      <Box
        classes={['flex', 'align-center', 'justify-between']}
        className={className}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        <Button
          onClick={prevPage}
          aria-label={title.prev}
          title={title.prev}
          disabled={prevDisabled}
          data-qa-id="carousel-left-button"
        >
          <Box transform="translateX(-1px)">
            <Icon
              name="chevron"
              direction="left"
              fill="currentColor"
              display="block"
            />
          </Box>
        </Button>
        <Button
          onClick={nextPage}
          aria-label={title.next}
          title={title.next}
          disabled={nextDisabled}
          data-qa-id="carousel-right-button"
        >
          <Box transform="translateX(1px)">
            <Icon
              name="chevron"
              direction="right"
              fill="currentColor"
              display="block"
            />
          </Box>
        </Button>
      </Box>
    );
  }
)`
  position: absolute;
  ${(props) =>
    !props.top &&
    `
    top: 50%;
  `}
  ${(props) =>
    props.width
      ? ``
      : `
      width: ${props.outset ? 'calc(100% + 128px)' : '100%'};
    `};
  max-width: calc(100vw - 16px);
  pointer-events: none;

  ${(props) =>
    props.outset
      ? `
    left: 50%;
    transform: translate(-50%, -50%);
    button {
      display: flex;
      width: 40px;
      height: 40px;
      padding: 0;
      justify-content: center;
      align-items: center;
      color: white;
      background: ${colors.waterBlue};
      border-radius: 50%;
      pointer-events: auto;
      transition: all ${transition};
      svg {
        * {
          fill: currentColor;
        }
      }
      &[disabled] {
        opacity: 0.33;
        &:hover {
          background: ${colors.waterBlue};
        }
      }
      &:hover,
      &:focus {
        background: ${colors.turtleGreen};
      }
    }`
      : `
    left: 0;
    transform: translateY(-50%);
    button {
      background: transparent;
      appearance: none;
      border: 0;
      padding: 0;
      pointer-events: all;
      color: ${props.buttonColor || colors.waterBlue};
      ${
        props.showDropShadow &&
        `
          filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.35));
        `
      }
      svg {
        * {
          fill: currentColor;
        }
      }
      &[disabled] {
        opacity: 0.33;
      }
    }
  `}
`;
// eslint-disable-next-line import/no-default-export
export default ArrowNavigation;
